module.exports = __webpack_public_path__ + "static/media/tad.01bb393c.png";